export default "__VITE_ASSET__bd75a4ed__"